import Image from 'next/image'

import { CopyrightText } from '@/components/copyright-text'

import { GuardianLayout } from '../guardian'

interface SignUpLayoutProps {
  title?: string
  headerRightNode?: React.ReactNode
  children: React.ReactNode
}

export const SignUpLayout = (props: SignUpLayoutProps): JSX.Element => {
  return (
    <GuardianLayout>
      <main className="flex min-h-screen flex-col bg-basic-bg">
        <header className="flex h-[50px] items-center bg-white px-2.5 md:h-[60px] md:px-[18px] lg:h-[70px]">
          <div className="flex-1">
            <Image
              src="/gApp_logo.svg"
              width={120}
              height={32}
              className="rounded-lg md:h-[40px] md:w-[150px]"
              alt="LogiQlabo"
            />
          </div>
          <div className="flex-1">
            {props.title && (
              <h2 className="text-center text-[11px] font-bold text-secondary-text md:text-lg lg:text-xl">
                {props.title}
              </h2>
            )}
          </div>
          <div className="flex flex-1 justify-end">{props.headerRightNode}</div>
        </header>
        <div className="flex grow flex-col">{props.children}</div>
        <footer className="mt-auto py-3.5">
          <p className="text-center text-[10px] font-medium text-secondary-93 md:text-xs">
            <CopyrightText />
          </p>
        </footer>
      </main>
    </GuardianLayout>
  )
}
